module.exports = __webpack_public_path__ + "static/pattern-pink-6177931b455cb731e14b0462c3a19685.png";